import ApiService from "./api.service";

let main = "candidateDocument";

export default {
    sendDocs({ data }) {
        let formData = new FormData();
        for (const id in data) {
            if (id === "regionId") {
                formData.append(id, data[id]);
            } else if (id === "licenceTypeIds") {
                formData.append(id, JSON.stringify(data[id]));
            } else {
                formData.append(`multipartFile`, data[id]);
                formData.append(`docTypeIds`, id);
            }
        }
        return ApiService.formData(`${main}/createCandidateDoc`, formData);
    },
    ownEmployee() {
        return ApiService.get(`${main}/ownEmployee`);
    },
    candidateDocument(id) {
        return ApiService.get(`${main}/get-by-candidateId/${id}`);
    },
    candidateDocumentHistory(candidateDocId) {
        return ApiService.get(
            `${main}History/history-by-candidateDocId/${candidateDocId}`
        );
    },
    updatePhoto(date) {
        return ApiService.get(`${main}/updatePhoto?givenDate=${date}`);
    },
    // GET http://localhost:8282/api/v.1/candidateDocument/passportDataByPinFL
    passportDataByPinFL(pinFL) {
        return ApiService.get(`${main}/passportDataByPinFL?pinFL=${pinFL}`);
    },
    // http://localhost:8282/api/v.1/candidateDocument/call-api
    callApi(inn) {
        return ApiService.post(`${main}/call-api`, { inn });
    },
    updateManual(data) {
        return ApiService.post("lawyerCandidate/update-manual", data);
    },
};
